import { SvgIcon } from "@mui/material";
import { IconProps } from "./_interface";

const IconPerformanceV2 = (props: IconProps) => {
  return (
    <SvgIcon {...props} color="inherit" viewBox="0 0 29 28">
      <path
        d="M6.16663 13.1C6.16663 12.6029 6.61434 12.2 7.16663 12.2C7.71891 12.2 8.16663 12.6029 8.16663 13.1V22.1C8.16663 22.5971 7.71891 23 7.16663 23C6.61434 23 6.16663 22.5971 6.16663 22.1V13.1Z"
        fill="#2E434D"
      />
      <path
        d="M11.1666 9.5C11.1666 9.00294 11.6143 8.6 12.1666 8.6C12.7189 8.6 13.1666 9.00294 13.1666 9.5V22.1C13.1666 22.5971 12.7189 23 12.1666 23C11.6143 23 11.1666 22.5971 11.1666 22.1V9.5Z"
        fill="#2E434D"
      />
      <path
        d="M21.1666 5.9C21.1666 5.40294 21.6143 5 22.1666 5C22.7189 5 23.1666 5.40294 23.1666 5.9V22.1C23.1666 22.5971 22.7189 23 22.1666 23C21.6143 23 21.1666 22.5971 21.1666 22.1V5.9Z"
        fill="#2E434D"
      />
      <path
        d="M16.1666 13.1C16.1666 12.6029 16.6143 12.2 17.1666 12.2C17.7189 12.2 18.1666 12.6029 18.1666 13.1V22.1C18.1666 22.5971 17.7189 23 17.1666 23C16.6143 23 16.1666 22.5971 16.1666 22.1V13.1Z"
        fill="#2E434D"
      />
    </SvgIcon>
  );
};

export default IconPerformanceV2;
